"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.galleryTags.name': 'Tagi Galerii',
    'tools.galleryTags.description': 'Zarządzaj i organizuj zawartość galerii za pomocą tagów',
};
